module.exports = __webpack_public_path__ + "img/logo-unis.af1dfdd6.png";